import { createGlobalStyle } from 'styled-components';

// #46699F
// #401694
const GlobalStyles = createGlobalStyle`

  :root {
    --primary-color:#46699F ;
    --secondary-color: #401694;
    --background-color: #E9EBED;
    --font-on-primary-color: #E9EBED;
    --font-on-secondary-color: #ffffff;
    --font-on-background-color: #5B616A;
    --accent-color: #0C6291;
    --primary-hover-color: #5A7FBB;
    --secondary-hover-color: #46699F;
    --font-on-secondary-hover-color: #FFFFFF;;
  }

  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    color:#000;
    font-family: "Open Sans", sans-serif;
  }
  * {box-sizing: border-box; }

  ::before, ::after {
    box-sizing: inherit;
  }
`;

export default GlobalStyles;